import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, CircularProgress, Button } from '@mui/material';
import MapPatnerEme from './MapFamily';
import { supabase } from '../../Supabase/supabaseRealtimeClient';

interface MapMarker {
  position: {
    lat: number;
    lng: number;
  };
  title: string;
  description?: string;
  type?: 'ambulancia' | 'paciente';
}

const FamilyEmergencyLocation: React.FC = () => {
  const [chamado, setChamado] = useState<any | null>(null);
  const [endereco, setEndereco] = useState<string | null>(null);
  const [distancia, setDistancia] = useState<string>('');
  const [estimativaTempo, setEstimativaTempo] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [routeCoords, setRouteCoords] = useState<{ lat: number; lng: number }[]>([]);
  const [loadingRoute, setLoadingRoute] = useState(false);
  const [routeDuration, setRouteDuration] = useState<number | null>(null);
  const [distanciaRota, setDistanciaRota] = useState<number | null>(null);
  
  // Estado para posição atual do socorrista (Realtime)
  const [socorristaPosAtual, setSocorristaPosAtual] = useState<{ lat: number; lng: number }>({ lat: -25.4284, lng: -49.2733 });

  // Função para buscar chamado via API
  const buscarChamadoAPI = async (chamadoId: number) => {
    console.log('[FamilyEmergencyLocation] ===== INÍCIO DA CHAMADA API =====');
    console.log('[FamilyEmergencyLocation] ENTRADA - chamadoId:', chamadoId);
    console.log('[FamilyEmergencyLocation] ENTRADA - Tipo do chamadoId:', typeof chamadoId);
    
    try {
      console.log('[FamilyEmergencyLocation] Fazendo requisição para Supabase...');
      setLoading(true);
      
      const startTime = Date.now();
      const { data, error } = await supabase
        .from('chamado')
        .select('*')
        .eq('id', chamadoId)
        .single();
      const endTime = Date.now();
      
      console.log('[FamilyEmergencyLocation] Tempo da requisição:', `${endTime - startTime}ms`);
      console.log('[FamilyEmergencyLocation] SAÍDA - Resposta completa:', { data, error });

      if (error) {
        console.error('[FamilyEmergencyLocation] ERRO NA API:', error);
        console.error('[FamilyEmergencyLocation] Código do erro:', error.code);
        console.error('[FamilyEmergencyLocation] Mensagem do erro:', error.message);
        console.error('[FamilyEmergencyLocation] Detalhes do erro:', error.details);
        throw error;
      }

      if (data) {
        console.log('[FamilyEmergencyLocation] SUCESSO - Chamado encontrado via API');
        console.log('[FamilyEmergencyLocation] DADOS RECEBIDOS:');
        console.log('   - ID:', data.id);
        console.log('   - Status:', data.status);
        console.log('   - Localização:', data.localizacao);
        console.log('   - Endereço textual:', data.endereco_textual);
        console.log('   - Data abertura:', data.data_abertura);
        console.log('   - Socorrista ID:', data.socorrista_id);
        console.log('   - Posição inicial socorrista:', data.posicao_inicial_socorrista);
        console.log('   - Cliente ID:', data.cliente_id);
        console.log('   - Dados completos:', data);
        
        setChamado(data);
        
        // Configurar posição inicial do socorrista usando posicao_inicial_socorrista
        if (data.posicao_inicial_socorrista) {
          const [lat, lng] = data.posicao_inicial_socorrista.split(',').map(Number);
          if (!isNaN(lat) && !isNaN(lng)) {
            setSocorristaPosAtual({ lat, lng });
            console.log('[FamilyEmergencyLocation] Posição inicial do socorrista configurada:', { lat, lng });
          } else {
            console.warn('[FamilyEmergencyLocation] Coordenadas inválidas do socorrista:', data.posicao_inicial_socorrista);
          }
        } else {
          console.warn('[FamilyEmergencyLocation] Campo posicao_inicial_socorrista não encontrado');
        }
        
        // Configurar endereço
        if (data.endereco_textual) {
          setEndereco(data.endereco_textual);
          console.log('[FamilyEmergencyLocation] Endereço configurado:', data.endereco_textual);
        } else {
          console.warn('[FamilyEmergencyLocation] Campo endereco_textual não encontrado');
        }
      } else {
        console.error('[FamilyEmergencyLocation] Chamado não encontrado na API');
        console.error('[FamilyEmergencyLocation] Resposta vazia do banco de dados');
      }
    } catch (error) {
      console.error('[FamilyEmergencyLocation] EXCEÇÃO CAPTURADA:', error);
      console.error('[FamilyEmergencyLocation] Tipo do erro:', typeof error);
      console.error('[FamilyEmergencyLocation] Stack trace:', error instanceof Error ? error.stack : 'N/A');
    } finally {
      setLoading(false);
      console.log('[FamilyEmergencyLocation] ===== FIM DA CHAMADA API =====');
    }
  };

  useEffect(() => {
    console.log('[FamilyEmergencyLocation] ===== INÍCIO DO USEEFFECT =====');
    
    // Buscar ID do chamado
    const chamadoId = localStorage.getItem('chamadoId');
    const chamadoFamilia = localStorage.getItem('chamadoFamilia');
    
    console.log('[FamilyEmergencyLocation] DADOS DO LOCALSTORAGE:');
    console.log('   - chamadoId:', chamadoId);
    console.log('   - chamadoFamilia:', chamadoFamilia ? 'Presente' : 'Ausente');
    
    if (chamadoId) {
      console.log('[FamilyEmergencyLocation] DECISÃO: Usar API com chamadoId');
      console.log('[FamilyEmergencyLocation] Iniciando busca via API...');
      // ✅ CHAMADA DE API - Buscar do banco de dados
      buscarChamadoAPI(Number(chamadoId));
    } else if (chamadoFamilia) {
      console.log('[FamilyEmergencyLocation] DECISÃO: Usar fallback localStorage');
      console.log('[FamilyEmergencyLocation] Parseando dados do localStorage...');
      // Fallback para localStorage
      const chamadoObj = JSON.parse(chamadoFamilia);
      console.log('[FamilyEmergencyLocation] Dados do localStorage:', chamadoObj);
      setChamado(chamadoObj);
      
      // ✅ CORREÇÃO: Usar posicao_inicial_socorrista em vez de localizacao
      if (chamadoObj && chamadoObj.posicao_inicial_socorrista) {
        const [lat, lng] = chamadoObj.posicao_inicial_socorrista.split(',').map(Number);
        if (!isNaN(lat) && !isNaN(lng)) {
          setSocorristaPosAtual({ lat, lng });
          console.log('[FamilyEmergencyLocation] Posição do socorrista do localStorage:', { lat, lng });
        } else {
          console.warn('[FamilyEmergencyLocation] Coordenadas inválidas do socorrista no localStorage:', chamadoObj.posicao_inicial_socorrista);
        }
      } else {
        console.warn('[FamilyEmergencyLocation] Campo posicao_inicial_socorrista não encontrado no localStorage');
        // Fallback para posição padrão se não houver dados do socorrista
        console.log('[FamilyEmergencyLocation] Usando posição padrão do socorrista');
      }
      
      setLoading(false);
    } else {
      console.error('[FamilyEmergencyLocation] DECISÃO: Nenhum chamado encontrado');
      console.error('[FamilyEmergencyLocation] Nenhum chamado encontrado');
      setLoading(false);
    }
    
    console.log('[FamilyEmergencyLocation] ===== FIM DO USEEFFECT =====');
  }, []);

  // Realtime para receber atualizações da posição do socorrista
  useEffect(() => {
    if (!chamado?.id) {
      console.log('[FamilyEmergencyLocation] Sem chamado ID para configurar Realtime');
      return;
    }

    console.log('[FamilyEmergencyLocation] Configurando Realtime para chamado:', chamado.id);

    const channel = supabase.channel('socorrista-position')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'chamado',
          filter: `id=eq.${chamado.id}`
        },
        (payload) => {
          console.log('[FamilyEmergencyLocation] Atualização recebida via Realtime:', payload);
          
          // Atualizar dados do chamado com as informações mais recentes
          if (payload.new) {
            console.log('[FamilyEmergencyLocation] DADOS ATUALIZADOS VIA REALTIME:');
            console.log('   - ID:', payload.new.id);
            console.log('   - Status:', payload.new.status);
            console.log('   - Localização cliente:', payload.new.localizacao);
            console.log('   - Posição inicial socorrista:', payload.new.posicao_inicial_socorrista);
            console.log('   - Endereço textual:', payload.new.endereco_textual);
            
            // Atualizar estado do chamado
            setChamado(payload.new);
            
            // Atualizar endereço se disponível
            if (payload.new.endereco_textual) {
              setEndereco(payload.new.endereco_textual);
            }
            
            // Atualizar posição do socorrista usando posicao_inicial_socorrista
            if (payload.new.posicao_inicial_socorrista) {
              const [lat, lng] = payload.new.posicao_inicial_socorrista.split(',').map(Number);
              if (!isNaN(lat) && !isNaN(lng)) {
                const novaPos = { lat, lng };
                console.log('[FamilyEmergencyLocation] Nova posição do socorrista:', novaPos);
                setSocorristaPosAtual(novaPos);
                
                // Recalcular rota com nova posição do socorrista
                if (payload.new.localizacao) {
                  const [destinoLat, destinoLng] = payload.new.localizacao.split(',').map(Number);
                  const destino = { lat: destinoLat, lng: destinoLng };
                  
                  console.log('[FamilyEmergencyLocation] REALTIME - Recalculando rota:');
                  console.log('   - ORIGEM (Socorrista):', novaPos);
                  console.log('   - DESTINO (Cliente):', destino);
                  
                  fetchRoute(novaPos, destino);
                }
              } else {
                console.warn('[FamilyEmergencyLocation] Coordenadas inválidas do socorrista no realtime:', payload.new.posicao_inicial_socorrista);
              }
            } else {
              console.warn('[FamilyEmergencyLocation] Campo posicao_inicial_socorrista não encontrado no realtime');
            }
          }
        }
      )
      .subscribe((status) => {
        console.log(`[FamilyEmergencyLocation] Status da subscription: ${status}`);
        if (status === 'SUBSCRIBED') {
          console.log('[FamilyEmergencyLocation] Realtime configurado com sucesso');
        }
      });

    return () => {
      console.log('[FamilyEmergencyLocation] Limpando subscription Realtime');
      supabase.removeChannel(channel);
    };
  }, [chamado?.id]);

  // Função para buscar rota OSRM
  const fetchRoute = async (socorristaPos: { lat: number; lng: number }, destino: { lat: number; lng: number }) => {
    setLoadingRoute(true);

    const url = `https://router.project-osrm.org/route/v1/driving/${socorristaPos.lng},${socorristaPos.lat};${destino.lng},${destino.lat}?overview=full&geometries=geojson&steps=true`;
    
    try {
      console.log('[FamilyEmergencyLocation] Buscando rota OSRM...', { socorrista: socorristaPos, destino });
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.routes && data.routes[0]) {
        const route = data.routes[0];
        const coords = route.geometry.coordinates.map(
          ([lng, lat]: [number, number]) => ({ lat, lng })
        );
        
        setRouteCoords(coords);
        
        // Duração em minutos
        const duration = Math.ceil(route.duration / 60);
        setRouteDuration(duration);
        setEstimativaTempo(`${duration} min`);
        
        // Distância em km
        const distance = route.distance / 1000;
        setDistanciaRota(distance);
        setDistancia(`${distance.toFixed(1)} km`);
        
        console.log('[FamilyEmergencyLocation] Rota atualizada:', {
          distancia: `${distance.toFixed(2)} km`,
          duracao: `${duration} min`,
          pontos: coords.length
        });
      }
    } catch (error) {
      console.error('[FamilyEmergencyLocation] Erro ao buscar rota:', error);
      // Fallback para cálculo simples se OSRM falhar
      const distanciaKm = calcularDistancia(socorristaPos.lat, socorristaPos.lng, destino.lat, destino.lng);
      setDistancia(`${distanciaKm.toFixed(2)} km`);
      const tempoMin = Math.ceil((distanciaKm / 40) * 60);
      setEstimativaTempo(`${tempoMin} min`);
    } finally {
      setLoadingRoute(false);
    }
  };

  // Buscar rota OSRM quando tiver o chamado (versão inicial)
  useEffect(() => {
    if (!chamado || !chamado.localizacao) return;

    const [destinoLat, destinoLng] = chamado.localizacao.split(',').map(Number);
    const destino = { lat: destinoLat, lng: destinoLng };
    
    // Usar posição atual do socorrista (ou fallback para estática)
    const posicaoSocorrista = socorristaPosAtual;
    
    console.log('[FamilyEmergencyLocation] MAPA - Pontos configurados:');
    console.log('   - ORIGEM (Socorrista):', posicaoSocorrista);
    console.log('   - DESTINO (Cliente):', destino);
    console.log('   - Endereço do cliente:', chamado.endereco_textual);
    
    fetchRoute(posicaoSocorrista, destino);
  }, [chamado, socorristaPosAtual]);

  useEffect(() => {
    if (chamado && chamado.localizacao) {
      // Buscar endereço textual se disponível
      if (chamado.endereco_textual) {
        setEndereco(chamado.endereco_textual);
      } else {
        const [lat, lon] = chamado.localizacao.split(',').map(Number);
        setEndereco(`${lat.toFixed(4)}, ${lon.toFixed(4)}`);
      }
    }
  }, [chamado]);

  function calcularDistancia(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function formatarDataHora(data: string) {
    if (!data) return '';
    const d = new Date(data);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    const hora = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} ${hora}:${min}`;
  }

  // Calcular bounds para incluir socorrista e cliente
  const calculateBounds = () => {
    if (!chamado || !chamado.localizacao) return null;
    
    const [clienteLat, clienteLng] = chamado.localizacao.split(',').map(Number);
    
    const latMin = Math.min(clienteLat, socorristaPosAtual.lat);
    const latMax = Math.max(clienteLat, socorristaPosAtual.lat);
    const lngMin = Math.min(clienteLng, socorristaPosAtual.lng);
    const lngMax = Math.max(clienteLng, socorristaPosAtual.lng);
    
    // Adicionar padding de 20%
    const latPadding = (latMax - latMin) * 0.2;
    const lngPadding = (lngMax - lngMin) * 0.2;
    
    return {
      north: latMax + latPadding,
      south: latMin - latPadding,
      east: lngMax + lngPadding,
      west: lngMin - lngPadding
    };
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      maxWidth: 800,
      mx: 'auto',
      minHeight: 'calc(100vh - 64px)',
      position: 'relative',
      overflow: 'hidden',
      pb: 2,
      mt: 3
    }}>
      <Paper elevation={0} sx={{
        borderRadius: 2,
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: 'none',
        maxWidth: 800,
        mx: 'auto',
        mb: 2,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        p: { xs: 2, sm: 3 },
        position: 'relative',
      }}>
        <Box
          component="img"
          src={require('../../assets/Design sem nome (7).png')}
          alt="Marca d'água Support Life"
          sx={{
            position: 'absolute',
            top: '55%',
            left: 0,
            width: '100%',
            height: '60%',
            objectFit: 'contain',
            opacity: 0.07,
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />
        <Typography variant="h6" sx={{ mb: 1, position: 'relative', zIndex: 1 }}>
          Acompanhamento do Socorro
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : chamado ? (
          <>
            <Box sx={{ width: '100%', minHeight: 350, maxHeight: 500, position: 'relative', zIndex: 1 }}>
              {(() => {
                const center = {
                  lat: Number(chamado.localizacao.split(',')[0]),
                  lng: Number(chamado.localizacao.split(',')[1])
                };
                const markerPaciente = {
                  position: {
                    lat: Number(chamado.localizacao.split(',')[0]),
                    lng: Number(chamado.localizacao.split(',')[1])
                  },
                  title: 'Local do paciente',
                  type: 'paciente' as 'paciente'
                };
                
                console.log('[FamilyEmergencyLocation] MAPA - Configuração do componente:');
                console.log('   - Center (cliente):', center);
                console.log('   - Marker paciente:', markerPaciente);
                console.log('   - Ambulance position (socorrista):', socorristaPosAtual);
                console.log('   - Route coords:', routeCoords.length, 'pontos');
                
                return (
                  <MapPatnerEme
                    center={center}
                    zoom={15}
                    markers={[markerPaciente]}
                    routeCoords={routeCoords}
                    ambulancePosition={socorristaPosAtual}
                  />
                );
              })()}
              {loadingRoute && (
                <Box sx={{ 
                  position: 'absolute', 
                  top: 10, 
                  right: 10, 
                  zIndex: 10,
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  p: 1,
                  boxShadow: 2
                }}>
                  <CircularProgress size={24} />
                </Box>
              )}
            </Box>
            
            {/* Seção de informações de distância e tempo */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between', 
              mt: 2, 
              position: 'relative', 
              zIndex: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: 2,
              p: 2,
              boxShadow: 1
            }}>
              {/* Tempo estimado */}
              <Box sx={{ textAlign: 'left', minWidth: 90 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>
                  {estimativaTempo || '--'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Tempo estimado
                </Typography>
              </Box>
              
              {/* Horário de chegada previsto */}
              <Box sx={{ flex: 1, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {(() => {
                    if (!estimativaTempo) return '--:--';
                    const tempoMin = parseInt(estimativaTempo.replace(/\D/g, '')) || 0;
                    const chegada = new Date();
                    chegada.setMinutes(chegada.getMinutes() + tempoMin);
                    return chegada.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                  })()}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Chegada prevista
                </Typography>
              </Box>
              
              {/* Distância */}
              <Box sx={{ textAlign: 'right', minWidth: 90 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {distancia || '--'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Distância
                </Typography>
              </Box>
            </Box>
            
            {/* Endereço do destino */}
            {endereco && (
              <Box sx={{ 
                mt: 2, 
                p: 2, 
                backgroundColor: 'rgba(245, 245, 245, 0.8)',
                borderRadius: 1,
                position: 'relative',
                zIndex: 1
              }}>
                <Typography variant="body2" color="text.secondary">
                  <strong>Endereço do atendimento:</strong>
                </Typography>
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                  {endereco}
                </Typography>
              </Box>
            )}
            

            
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'row', 
              gap: 2, 
              mt: 3, 
              width: '100%', 
              justifyContent: 'space-between', 
              position: 'relative', 
              zIndex: 1 
            }}>
              <Button
                variant="outlined"
                color="primary"
                sx={{
                  width: '100%',
                  minWidth: 120,
                  fontWeight: 600,
                  backgroundColor: '#fff',
                  color: (theme) => theme.palette.primary.main,
                  borderColor: (theme) => theme.palette.primary.main,
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.primary.light,
                    color: '#fff',
                  },
                }}
                onClick={() => window.history.back()}
              >
                Voltar
              </Button>
            </Box>
          </>
        ) : (
          <Typography variant="body2" color="error">Chamado não encontrado.</Typography>
        )}
      </Paper>
    </Box>
  );
};

export default FamilyEmergencyLocation;